// Reference: https://dlinko365.sharepoint.com/:x:/t/NewHopePlatform-DeviceManagementArchitecture/IQA7waObOqRfQK1rG6rwG7UKAVT8FyPpTWyb_zb8_K9oXC4?e=69UKwP
export const channelOptions = {
  "2.4GHz": [
    { label: "Auto", value: "Auto" },
    { label: "1/2412", value: "1" },
    { label: "2/2417", value: "2" },
    { label: "3/2422", value: "3" },
    { label: "4/2427", value: "4" },
    { label: "5/2432", value: "5" },
    { label: "6/2437", value: "6" },
    { label: "7/2442", value: "7" },
    { label: "8/2447", value: "8" },
    { label: "9/2452", value: "9" },
    { label: "10/2457", value: "10" },
    { label: "11/2462", value: "11" },
    { label: "12/2467", value: "12" },
    { label: "13/2472", value: "13" },
    { label: "14/2477", value: "14" },
  ],
  "5GHz": [
    { label: "Auto", value: "Auto" },
    { label: "36/5180", value: "36" },
    { label: "40/5200", value: "40" },
    { label: "44/5220", value: "44" },
    { label: "48/5240", value: "48" },
    { label: "52/5260(DFS)", value: "52" },
    { label: "56/5280(DFS)", value: "56" },
    { label: "60/5300(DFS)", value: "60" },
    { label: "64/5320(DFS)", value: "64" },
    { label: "100/5500(DFS)", value: "100" },
    { label: "104/5520(DFS)", value: "104" },
    { label: "108/5540(DFS)", value: "108" },
    { label: "112/5560(DFS)", value: "112" },
    { label: "116/5580(DFS)", value: "116" },
    { label: "120/5600(DFS)", value: "120" },
    { label: "124/5620(DFS)", value: "124" },
    { label: "128/5640(DFS)", value: "128" },
    { label: "132/5660(DFS)", value: "132" },
    { label: "136/5680(DFS)", value: "136" },
    { label: "140/5700(DFS)", value: "140" },
    { label: "144/5720(DFS)", value: "144" },
    { label: "149/5745", value: "149" },
    { label: "153/5765", value: "153" },
    { label: "157/5785", value: "157" },
    { label: "161/5805", value: "161" },
    { label: "165/5825", value: "165" },
    { label: "169/5845", value: "169" },
    { label: "173/5865", value: "173" },
    { label: "177/5885", value: "177" },
    { label: "181/5905", value: "181" },
  ],
  "6GHz": [
    { label: "Auto", value: "Auto" },
    { label: "5/6035", value: "5" },
    { label: "21/6355", value: "21" },
    { label: "37/6675", value: "37" },
    { label: "53/6995", value: "53" },
    { label: "69/7315", value: "69" },
    { label: "85/7635", value: "85" },
    { label: "101/7955", value: "101" },
    { label: "117/8275", value: "117" },
    { label: "133/8595", value: "133" },
    { label: "149/8915", value: "149" },
    { label: "165/9235", value: "165" },
    { label: "181/9555", value: "181" },
    { label: "197/9875", value: "197" },
    { label: "213/10195", value: "213" },
    { label: "229/10515", value: "229" },
  ],
};

export const channelWidthOptions = {
  "2.4GHz": [
    { label: "20 MHz", value: "20" },
    { label: "40 MHz", value: "40" },
    { label: "Auto", value: "Auto" },
  ],
  "5GHz": [
    { label: "20 MHz", value: "20" },
    { label: "40 MHz", value: "40" },
    { label: "80 MHz", value: "80" },
    { label: "160 MHz", value: "160" },
    { label: "Auto", value: "Auto" },
  ],
  "6GHz": [
    { label: "80 MHz", value: "80" },
    { label: "160 MHz", value: "160" },
    { label: "320 MHz", value: "320" },
    { label: "Auto", value: "Auto" },
  ],
};

// export const wirelessModeOptions = {
//   "2.4GHz": [
//     { label: "Auto", value: "Auto" },
//     { label: "802.11b Only", value: "b" },
//     { label: "Mixed 802.11b/g", value: "bg" },
//     { label: "Mixed 802.11n Only", value: "n" },
//     { label: "Mixed 802.11b/g/n/ax", value: "anacax" },
//     { label: "Mixed 802.11b/g/n/ax/be", value: "anacaxbe" }, // Wi-Fi 7 only
//   ],
//   "5GHz": [
//     { label: "Auto", value: "Auto" },
//     { label: "802.11a Only", value: "a" },
//     { label: "802.11n Only", value: "n" },
//     { label: "Mixed 802.11a/n", value: "an" },
//     { label: "Mixed 802.11a/n/ac", value: "anac" },
//     { label: "Mixed 802.11a/n/ac/ax", value: "anacax" },
//     { label: "Mixed 802.11a/n/ac/ax/be", value: "anacaxbe" }, // Wi-Fi 7 only
//   ],
//   "6GHz": [
//     { label: "Auto", value: "Auto" },
//     { label: "802.11ax Only", value: "ax" }, // Wi-Fi 7 only
//     { label: "Mixed 802.11ax/be", value: "axbe" }, // Wi-Fi 7 only
//   ],
// };

export const wirelessModeOptions = {
  "2.4GHz": [
    { label: "Auto", value: "Auto", wifi6: true, wifi7: true },
    { label: "802.11n Only", value: "n", wifi6: true, wifi7: true },
    { label: "Mixed 802.11b/g", value: "bg", wifi6: true, wifi7: true },
    { label: "Mixed 802.11b/g/n/ax", value: "bgnaxbe", wifi6: true, wifi7: false },
    { label: "Mixed 802.11b/g/n/ax/be", value: "bgnaxbe", wifi6: false, wifi7: true },
  ],
  "5GHz": [
    { label: "Auto", value: "Auto", wifi6: true, wifi7: true },
    { label: "802.11a Only", value: "a", wifi6: true, wifi7: true },
    { label: "802.11n Only", value: "n", wifi6: true, wifi7: true },
    { label: "Mixed 802.11a/n", value: "an", wifi6: true, wifi7: true },
    { label: "Mixed 802.11a/n/ac/ax", value: "anacaxbe", wifi6: true, wifi7: false },
    { label: "Mixed 802.11a/n/ac/ax/be", value: "anacaxbe", wifi6: false, wifi7: true },
  ],
  "6GHz": [
    { label: "Auto", value: "Auto", wifi6: false, wifi7: true },
    { label: "802.11ax Only", value: "ax", wifi6: false, wifi7: true },
    { label: "Mixed 802.11ax/be", value: "axbe", wifi6: false, wifi7: true },
  ],
};

export const txPowerOptions = [
  { label: "100%", value: 100 },
  { label: "50%", value: 50 },
  { label: "25%", value: 25 },
  { label: "12.5%", value: 12 },
];

export const rssiOptions = [
  { label: "Disable", value: "Disable" },
  { label: "10%", value: 10 },
  { label: "20%", value: 20 },
  { label: "30%", value: 30 },
  { label: "40%", value: 40 },
  { label: "50%", value: 50 },
  { label: "60%", value: 60 },
  { label: "70%", value: 70 },
  { label: "80%", value: 80 },
  { label: "90%", value: 90 },
  { label: "100%", value: 100 },
];


// Reference: https://dlinko365.sharepoint.com/:x:/r/teams/NewHopePlatform/_layouts/15/Doc.aspx?sourcedoc=%7B00C24091-96B8-4165-AA42-41467684E951%7D&file=Country-domain%20Mapping%20table_20251001.xlsx&action=default&mobileredirect=true
export const countryDomainOptions = {
  "2.4GHz": {
    '1': { country: 'Afghanistan', domain: 'EU/UK' },
    '2': { country: 'Aland Islands', domain: 'EU/UK' },
    '3': { country: 'Albania', domain: 'EU/UK' },
    '4': { country: 'Algeria', domain: 'EU/UK' },
    '5': { country: 'American Samoa', domain: 'US/NA' },
    '6': { country: 'Andorra', domain: 'EU/UK' },
    '7': { country: 'Angola', domain: 'EU/UK' },
    '8': { country: 'Anguilla', domain: 'EU/UK' },
    '9': { country: 'Antarctica', domain: 'EU/UK' },
    '10': { country: 'Antigua and Barbuda', domain: 'AU' },
    '11': { country: 'Argentina', domain: 'AU' },
    '12': { country: 'Armenia', domain: 'RU' },
    '13': { country: 'Aruba', domain: 'AU' },
    '14': { country: 'Australia', domain: 'AU' },
    '15': { country: 'Austria', domain: 'EU/UK' },
    '16': { country: 'Azerbaijan', domain: 'RU' },
    '17': { country: 'Bahamas', domain: 'AU' },
    '18': { country: 'Bahrain', domain: 'EU/UK' },
    '19': { country: 'Bangladesh', domain: 'IN' },
    '20': { country: 'Barbados', domain: 'AU' },
    '21': { country: 'Belarus', domain: 'BY' },
    '22': { country: 'Belgium', domain: 'EU/UK' },
    '23': { country: 'Belize', domain: 'AU' },
    '24': { country: 'Benin', domain: 'EU/UK' },
    '25': { country: 'Bermuda', domain: 'EU/UK' },
    '26': { country: 'Bhutan', domain: 'IN' },
    '27': { country: 'Bolivia', domain: 'AU' },
    '28': { country: 'Bonaire, Saint Eustatius and Saba ', domain: 'AU' },
    '29': { country: 'Bosnia and Herzegovina', domain: 'EU/UK' },
    '30': { country: 'Botswana', domain: 'EU/UK' },
    '31': { country: 'Brazil', domain: 'AU' },
    '32': { country: 'British Indian Ocean Territory', domain: 'EU/UK' },
    '33': { country: 'British Virgin Islands', domain: 'EU/UK' },
    '34': { country: 'Brunei', domain: 'EU/UK' },
    '35': { country: 'Bulgaria', domain: 'EU/UK' },
    '36': { country: 'Burkina Faso', domain: 'EU/UK' },
    '37': { country: 'Burundi', domain: 'EU/UK' },
    '38': { country: 'Cambodia', domain: 'SG' },
    '39': { country: 'Cameroon', domain: 'EU/UK' },
    '40': { country: 'Canada', domain: 'US/NA' },
    '41': { country: 'Cape Verde', domain: 'EU/UK' },
    '42': { country: 'Cayman Islands', domain: 'EU/UK' },
    '43': { country: 'Central African Republic', domain: 'EU/UK' },
    '44': { country: 'Chad', domain: 'EU/UK' },
    '45': { country: 'Chile', domain: 'AU' },
    '46': { country: 'China', domain: 'CN' },
    '47': { country: 'Christmas Island', domain: 'AU' },
    '48': { country: 'Cocos Islands', domain: 'EU/UK' },
    '49': { country: 'Colombia', domain: 'AU' },
    '50': { country: 'Comoros', domain: 'EU/UK' },
    '51': { country: 'Cook Islands', domain: 'EU/UK' },
    '52': { country: 'Costa Rica', domain: 'AU' },
    '53': { country: 'Croatia', domain: 'EU/UK' },
    '54': { country: 'Cuba', domain: 'AU' },
    '55': { country: 'Cura�ao', domain: 'EU/UK' },
    '56': { country: 'Cyprus', domain: 'EU/UK' },
    '57': { country: 'Czech Republic', domain: 'EU/UK' },
    '58': { country: 'Democratic Republic of the Congo', domain: 'EU/UK' },
    '59': { country: 'Denmark', domain: 'EU/UK' },
    '60': { country: 'Djibouti', domain: 'EU/UK' },
    '61': { country: 'Dominica', domain: 'EU/UK' },
    '62': { country: 'Dominican Republic', domain: 'EU/UK' },
    '63': { country: 'East Timor', domain: 'EU/UK' },
    '64': { country: 'Ecuador', domain: 'AU' },
    '65': { country: 'Egypt', domain: 'EU/UK' },
    '66': { country: 'El Salvador', domain: 'AU' },
    '67': { country: 'Equatorial Guinea', domain: 'EU/UK' },
    '68': { country: 'Eritrea', domain: 'EU/UK' },
    '69': { country: 'Estonia', domain: 'EU/UK' },
    '70': { country: 'Ethiopia', domain: 'EU/UK' },
    '71': { country: 'Falkland Islands', domain: 'EU/UK' },
    '72': { country: 'Faroe Islands', domain: 'EU/UK' },
    '73': { country: 'Fiji', domain: 'EU/UK' },
    '74': { country: 'Finland', domain: 'EU/UK' },
    '75': { country: 'France', domain: 'EU/UK' },
    '76': { country: 'French Guiana', domain: 'EU/UK' },
    '77': { country: 'French Polynesia', domain: 'EU/UK' },
    '78': { country: 'French Southern Territories', domain: 'EU/UK' },
    '79': { country: 'Gabon', domain: 'EU/UK' },
    '80': { country: 'Gambia', domain: 'EU/UK' },
    '81': { country: 'Georgia', domain: 'EU/UK' },
    '82': { country: 'Germany', domain: 'EU/UK' },
    '83': { country: 'Ghana', domain: 'EU/UK' },
    '84': { country: 'Gibraltar', domain: 'EU/UK' },
    '85': { country: 'Greece', domain: 'EU/UK' },
    '86': { country: 'Greenland', domain: 'EU/UK' },
    '87': { country: 'Grenada', domain: 'EU/UK' },
    '88': { country: 'Guadeloupe', domain: 'EU/UK' },
    '89': { country: 'Guam', domain: 'US/NA' },
    '90': { country: 'Guatemala', domain: 'AU' },
    '91': { country: 'Guernsey', domain: 'EU/UK' },
    '92': { country: 'Guinea', domain: 'EU/UK' },
    '93': { country: 'Guinea-Bissau', domain: 'EU/UK' },
    '94': { country: 'Guyana', domain: 'EU/UK' },
    '95': { country: 'Haiti', domain: 'EU/UK' },
    '96': { country: 'Honduras', domain: 'AU' },
    '97': { country: 'Hong Kong', domain: 'HK' },
    '98': { country: 'Hungary', domain: 'EU/UK' },
    '99': { country: 'Iceland', domain: 'EU/UK' },
    '100': { country: 'India', domain: 'IN' },
    '101': { country: 'Indonesia', domain: 'SG' },
    '102': { country: 'Iran', domain: 'EU/UK' },
    '103': { country: 'Iraq', domain: 'EU/UK' },
    '104': { country: 'Ireland', domain: 'EU/UK' },
    '105': { country: 'Isle of Man', domain: 'EU/UK' },
    '106': { country: 'Israel', domain: 'EU/UK' },
    '107': { country: 'Italy', domain: 'EU/UK' },
    '108': { country: 'Ivory Coast', domain: 'EU/UK' },
    '109': { country: 'Jamaica', domain: 'AU' },
    '110': { country: 'Japan', domain: 'JP' },
    '111': { country: 'Jersey', domain: 'EU/UK' },
    '112': { country: 'Jordan', domain: 'EU/UK' },
    '113': { country: 'Kazakhstan', domain: 'EU/UK' },
    '114': { country: 'Kenya', domain: 'EU/UK' },
    '115': { country: 'Kiribati', domain: 'EU/UK' },
    '116': { country: 'Kuwait', domain: 'EU/UK' },
    '117': { country: 'Kyrgyzstan', domain: 'RU' },
    '118': { country: 'Laos', domain: 'SG' },
    '119': { country: 'Latvia', domain: 'EU/UK' },
    '120': { country: 'Lebanon', domain: 'EU/UK' },
    '121': { country: 'Lesotho', domain: 'EU/UK' },
    '122': { country: 'Liberia', domain: 'EU/UK' },
    '123': { country: 'Libya', domain: 'EU/UK' },
    '124': { country: 'Liechtenstein', domain: 'EU/UK' },
    '125': { country: 'Lithuania', domain: 'EU/UK' },
    '126': { country: 'Luxembourg', domain: 'EU/UK' },
    '127': { country: 'Macao', domain: 'CN' },
    '128': { country: 'Macedonia', domain: 'EU/UK' },
    '129': { country: 'Madagascar', domain: 'EU/UK' },
    '130': { country: 'Malawi', domain: 'EU/UK' },
    '131': { country: 'Malaysia', domain: 'EU/UK' },
    '132': { country: 'Maldives', domain: 'EU/UK' },
    '133': { country: 'Mali', domain: 'EU/UK' },
    '134': { country: 'Malta', domain: 'EU/UK' },
    '135': { country: 'Marshall Islands', domain: 'US/NA' },
    '136': { country: 'Martinique', domain: 'EU/UK' },
    '137': { country: 'Mauritania', domain: 'EU/UK' },
    '138': { country: 'Mauritius', domain: 'EU/UK' },
    '139': { country: 'Mayotte', domain: 'EU/UK' },
    '140': { country: 'Mexico', domain: 'AU' },
    '141': { country: 'Micronesia', domain: 'EU/UK' },
    '142': { country: 'Moldova', domain: 'RU' },
    '143': { country: 'Monaco', domain: 'EU/UK' },
    '144': { country: 'Mongolia', domain: 'RU' },
    '145': { country: 'Montenegro', domain: 'EU/UK' },
    '146': { country: 'Montserrat', domain: 'EU/UK' },
    '147': { country: 'Morocco', domain: 'EU/UK' },
    '148': { country: 'Mozambique', domain: 'EU/UK' },
    '149': { country: 'Myanmar', domain: 'SG' },
    '150': { country: 'Namibia', domain: 'EU/UK' },
    '151': { country: 'Nauru', domain: 'AU' },
    '152': { country: 'Nepal', domain: 'EU/UK' },
    '153': { country: 'Netherlands', domain: 'EU/UK' },
    '154': { country: 'New Caledonia', domain: 'EU/UK' },
    '155': { country: 'New Zealand', domain: 'AU' },
    '156': { country: 'Nicaragua', domain: 'AU' },
    '157': { country: 'Niger', domain: 'EU/UK' },
    '158': { country: 'Nigeria', domain: 'EU/UK' },
    '159': { country: 'Niue', domain: 'AU' },
    '160': { country: 'Norfolk Island', domain: 'AU' },
    '161': { country: 'North Korea', domain: 'EU/UK' },
    '162': { country: 'Northern Mariana Islands', domain: 'US/NA' },
    '163': { country: 'Norway', domain: 'EU/UK' },
    '164': { country: 'Oman', domain: 'EU/UK' },
    '165': { country: 'Pakistan', domain: 'EU/UK' },
    '166': { country: 'Palau', domain: 'US/NA' },
    '167': { country: 'Palestinian Territory', domain: 'EU/UK' },
    '168': { country: 'Panama', domain: 'AU' },
    '169': { country: 'Papua New Guinea', domain: 'EU/UK' },
    '170': { country: 'Paraguay', domain: 'AU' },
    '171': { country: 'Peru', domain: 'AU' },
    '172': { country: 'Philippines', domain: 'SG' },
    '173': { country: 'Pitcairn', domain: 'EU/UK' },
    '174': { country: 'Poland', domain: 'EU/UK' },
    '175': { country: 'Portugal', domain: 'EU/UK' },
    '176': { country: 'Puerto Rico', domain: 'US/NA' },
    '177': { country: 'Qatar', domain: 'EU/UK' },
    '178': { country: 'Republic of the Congo', domain: 'EU/UK' },
    '179': { country: 'Reunion', domain: 'EU/UK' },
    '180': { country: 'Romania', domain: 'EU/UK' },
    '181': { country: 'Russia', domain: 'RU' },
    '182': { country: 'Rwanda', domain: 'EU/UK' },
    '183': { country: 'Saint Barth�lemy', domain: 'AU' },
    '184': { country: 'Saint Helena', domain: 'EU/UK' },
    '185': { country: 'Saint Kitts and Nevis', domain: 'AU' },
    '186': { country: 'Saint Lucia', domain: 'EU/UK' },
    '187': { country: 'Saint Martin', domain: 'EU/UK' },
    '188': { country: 'Saint Pierre and Miquelon', domain: 'EU/UK' },
    '189': { country: 'Saint Vincent and the Grenadines', domain: 'EU/UK' },
    '190': { country: 'Samoa', domain: 'EU/UK' },
    '191': { country: 'San Marino', domain: 'EU/UK' },
    '192': { country: 'Sao Tome and Principe', domain: 'EU/UK' },
    '193': { country: 'Saudi Arabia', domain: 'EU/UK' },
    '194': { country: 'Senegal', domain: 'EU/UK' },
    '195': { country: 'Serbia', domain: 'EU/UK' },
    '196': { country: 'Seychelles', domain: 'EU/UK' },
    '197': { country: 'Sierra Leone', domain: 'EU/UK' },
    '198': { country: 'Singapore', domain: 'SG' },
    '199': { country: 'Sint Maarten', domain: 'EU/UK' },
    '200': { country: 'Slovakia', domain: 'EU/UK' },
    '201': { country: 'Solomon Islands', domain: 'EU/UK' },
    '202': { country: 'Somalia', domain: 'EU/UK' },
    '203': { country: 'South Africa', domain: 'EU/UK' },
    '204': { country: 'South Georgia and the South Sandwich Islands', domain: 'EU/UK' },
    '205': { country: 'South Korea', domain: 'KR' },
    '206': { country: 'South Sudan', domain: 'EU/UK' },
    '207': { country: 'Spain', domain: 'EU/UK' },
    '208': { country: 'Sri Lanka', domain: 'EU/UK' },
    '209': { country: 'Sudan', domain: 'EU/UK' },
    '210': { country: 'Suriname', domain: 'AU' },
    '211': { country: 'Svalbard and Jan Mayen', domain: 'EU/UK' },
    '212': { country: 'Swaziland', domain: 'EU/UK' },
    '213': { country: 'Sweden', domain: 'EU/UK' },
    '214': { country: 'Switzerland', domain: 'EU/UK' },
    '215': { country: 'Syria', domain: 'EU/UK' },
    '216': { country: 'Taiwan', domain: 'US/NA' },
    '217': { country: 'Tajikistan', domain: 'RU' },
    '218': { country: 'Tanzania', domain: 'EU/UK' },
    '219': { country: 'Thailand', domain: 'EU/UK' },
    '220': { country: 'Togo', domain: 'EU/UK' },
    '221': { country: 'Tokelau', domain: 'AU' },
    '222': { country: 'Tonga', domain: 'EU/UK' },
    '223': { country: 'Trinidad and Tobago', domain: 'EU/UK' },
    '224': { country: 'Tunisia', domain: 'EU/UK' },
    '225': { country: 'Turkey', domain: 'EU/UK' },
    '226': { country: 'Turkmenistan', domain: 'RU' },
    '227': { country: 'Turks and Caicos Islands', domain: 'EU/UK' },
    '228': { country: 'Tuvalu', domain: 'EU/UK' },
    '229': { country: 'U.S. Virgin Islands', domain: 'US/NA' },
    '230': { country: 'Uganda', domain: 'EU/UK' },
    '231': { country: 'Ukraine', domain: 'RU' },
    '232': { country: 'United Arab Emirates', domain: 'EU/UK' },
    '233': { country: 'United Kingdom', domain: 'EU/UK' },
    '234': { country: 'United States', domain: 'US/NA' },
    '235': { country: 'United States Minor Outlying Islands', domain: 'US/NA' },
    '236': { country: 'Universal', domain: 'DL' },
    '237': { country: 'Uruguay', domain: 'AU' },
    '238': { country: 'Uzbekistan', domain: 'RU' },
    '239': { country: 'Vanuatu', domain: 'EU/UK' },
    '240': { country: 'Vatican', domain: 'EU/UK' },
    '241': { country: 'Venezuela', domain: 'AU' },
    '242': { country: 'Vietnam', domain: 'SG' },
    '243': { country: 'Wallis and Futuna', domain: 'EU/UK' },
    '244': { country: 'Western Sahara', domain: 'EU/UK' },
    '245': { country: 'Yemen', domain: 'EU/UK' },
    '246': { country: 'Zambia', domain: 'EU/UK' },
    '247': { country: 'Zimbabwe', domain: 'EU/UK' },
    '248': { country: 'Kosovo', domain: 'EU/UK' },
    '249': { country: 'Slovenia', domain: 'EU/UK' },
  },
  "5GHz": {
    '1': { country: 'Afghanistan', domain: 'EU/UK' },
    '2': { country: 'Aland Islands', domain: 'EU/UK' },
    '3': { country: 'Albania', domain: 'EU/UK' },
    '4': { country: 'Algeria', domain: 'EU/UK' },
    '5': { country: 'American Samoa', domain: 'US/NA' },
    '6': { country: 'Andorra', domain: 'EU/UK' },
    '7': { country: 'Angola', domain: 'EU/UK' },
    '8': { country: 'Anguilla', domain: 'EU/UK' },
    '9': { country: 'Antarctica', domain: 'EU/UK' },
    '10': { country: 'Antigua and Barbuda', domain: 'LA' },
    '11': { country: 'Argentina', domain: 'LA' },
    '12': { country: 'Armenia', domain: 'RU' },
    '13': { country: 'Aruba', domain: 'LA' },
    '14': { country: 'Australia', domain: 'AU' },
    '15': { country: 'Austria', domain: 'EU/UK' },
    '16': { country: 'Azerbaijan', domain: 'RU' },
    '17': { country: 'Bahamas', domain: 'LA' },
    '18': { country: 'Bahrain', domain: 'EU/UK' },
    '19': { country: 'Bangladesh', domain: 'IN' },
    '20': { country: 'Barbados', domain: 'LA' },
    '21': { country: 'Belarus', domain: 'BY' },
    '22': { country: 'Belgium', domain: 'EU/UK' },
    '23': { country: 'Belize', domain: 'LA' },
    '24': { country: 'Benin', domain: 'EU/UK' },
    '25': { country: 'Bermuda', domain: 'EU/UK' },
    '26': { country: 'Bhutan', domain: 'IN' },
    '27': { country: 'Bolivia', domain: 'LA' },
    '28': { country: 'Bonaire, Saint Eustatius and Saba ', domain: 'AU' },
    '29': { country: 'Bosnia and Herzegovina', domain: 'EU/UK' },
    '30': { country: 'Botswana', domain: 'EU/UK' },
    '31': { country: 'Brazil', domain: 'BR' },
    '32': { country: 'British Indian Ocean Territory', domain: 'EU/UK' },
    '33': { country: 'British Virgin Islands', domain: 'EU/UK' },
    '34': { country: 'Brunei', domain: 'EU/UK' },
    '35': { country: 'Bulgaria', domain: 'EU/UK' },
    '36': { country: 'Burkina Faso', domain: 'EU/UK' },
    '37': { country: 'Burundi', domain: 'EU/UK' },
    '38': { country: 'Cambodia', domain: 'SG' },
    '39': { country: 'Cameroon', domain: 'EU/UK' },
    '40': { country: 'Canada', domain: 'CA' },
    '41': { country: 'Cape Verde', domain: 'EU/UK' },
    '42': { country: 'Cayman Islands', domain: 'EU/UK' },
    '43': { country: 'Central African Republic', domain: 'EU/UK' },
    '44': { country: 'Chad', domain: 'EU/UK' },
    '45': { country: 'Chile', domain: 'LA' },
    '46': { country: 'China', domain: 'CN' },
    '47': { country: 'Christmas Island', domain: 'AU' },
    '48': { country: 'Cocos Islands', domain: 'EU/UK' },
    '49': { country: 'Colombia', domain: 'LA' },
    '50': { country: 'Comoros', domain: 'EU/UK' },
    '51': { country: 'Cook Islands', domain: 'EU/UK' },
    '52': { country: 'Costa Rica', domain: 'LA' },
    '53': { country: 'Croatia', domain: 'EU/UK' },
    '54': { country: 'Cuba', domain: 'LA' },
    '55': { country: 'Cura�ao', domain: 'EU/UK' },
    '56': { country: 'Cyprus', domain: 'EU/UK' },
    '57': { country: 'Czech Republic', domain: 'EU/UK' },
    '58': { country: 'Democratic Republic of the Congo', domain: 'EU/UK' },
    '59': { country: 'Denmark', domain: 'EU/UK' },
    '60': { country: 'Djibouti', domain: 'EU/UK' },
    '61': { country: 'Dominica', domain: 'EU/UK' },
    '62': { country: 'Dominican Republic', domain: 'EU/UK' },
    '63': { country: 'East Timor', domain: 'EU/UK' },
    '64': { country: 'Ecuador', domain: 'LA' },
    '65': { country: 'Egypt', domain: 'EG' },
    '66': { country: 'El Salvador', domain: 'LA' },
    '67': { country: 'Equatorial Guinea', domain: 'EU/UK' },
    '68': { country: 'Eritrea', domain: 'EU/UK' },
    '69': { country: 'Estonia', domain: 'EU/UK' },
    '70': { country: 'Ethiopia', domain: 'EU/UK' },
    '71': { country: 'Falkland Islands', domain: 'EU/UK' },
    '72': { country: 'Faroe Islands', domain: 'EU/UK' },
    '73': { country: 'Fiji', domain: 'EU/UK' },
    '74': { country: 'Finland', domain: 'EU/UK' },
    '75': { country: 'France', domain: 'EU/UK' },
    '76': { country: 'French Guiana', domain: 'EU/UK' },
    '77': { country: 'French Polynesia', domain: 'EU/UK' },
    '78': { country: 'French Southern Territories', domain: 'EU/UK' },
    '79': { country: 'Gabon', domain: 'EU/UK' },
    '80': { country: 'Gambia', domain: 'EU/UK' },
    '81': { country: 'Georgia', domain: 'EU/UK' },
    '82': { country: 'Germany', domain: 'EU/UK' },
    '83': { country: 'Ghana', domain: 'EU/UK' },
    '84': { country: 'Gibraltar', domain: 'EU/UK' },
    '85': { country: 'Greece', domain: 'EU/UK' },
    '86': { country: 'Greenland', domain: 'EU/UK' },
    '87': { country: 'Grenada', domain: 'EU/UK' },
    '88': { country: 'Guadeloupe', domain: 'EU/UK' },
    '89': { country: 'Guam', domain: 'US/NA' },
    '90': { country: 'Guatemala', domain: 'LA' },
    '91': { country: 'Guernsey', domain: 'EU/UK' },
    '92': { country: 'Guinea', domain: 'EU/UK' },
    '93': { country: 'Guinea-Bissau', domain: 'EU/UK' },
    '94': { country: 'Guyana', domain: 'EU/UK' },
    '95': { country: 'Haiti', domain: 'EU/UK' },
    '96': { country: 'Honduras', domain: 'LA' },
    '97': { country: 'Hong Kong', domain: 'HK' },
    '98': { country: 'Hungary', domain: 'EU/UK' },
    '99': { country: 'Iceland', domain: 'EU/UK' },
    '100': { country: 'India', domain: 'IN' },
    '101': { country: 'Indonesia', domain: 'SG' },
    '102': { country: 'Iran', domain: 'EU/UK' },
    '103': { country: 'Iraq', domain: 'EU/UK' },
    '104': { country: 'Ireland', domain: 'EU/UK' },
    '105': { country: 'Isle of Man', domain: 'EU/UK' },
    '106': { country: 'Israel', domain: 'IL' },
    '107': { country: 'Italy', domain: 'EU/UK' },
    '108': { country: 'Ivory Coast', domain: 'EU/UK' },
    '109': { country: 'Jamaica', domain: 'LA' },
    '110': { country: 'Japan', domain: 'JP' },
    '111': { country: 'Jersey', domain: 'EU/UK' },
    '112': { country: 'Jordan', domain: 'EU/UK' },
    '113': { country: 'Kazakhstan', domain: 'EU/UK' },
    '114': { country: 'Kenya', domain: 'EU/UK' },
    '115': { country: 'Kiribati', domain: 'EU/UK' },
    '116': { country: 'Kuwait', domain: 'EU/UK' },
    '117': { country: 'Kyrgyzstan', domain: 'RU' },
    '118': { country: 'Laos', domain: 'SG' },
    '119': { country: 'Latvia', domain: 'EU/UK' },
    '120': { country: 'Lebanon', domain: 'EU/UK' },
    '121': { country: 'Lesotho', domain: 'EU/UK' },
    '122': { country: 'Liberia', domain: 'EU/UK' },
    '123': { country: 'Libya', domain: 'EU/UK' },
    '124': { country: 'Liechtenstein', domain: 'EU/UK' },
    '125': { country: 'Lithuania', domain: 'EU/UK' },
    '126': { country: 'Luxembourg', domain: 'EU/UK' },
    '127': { country: 'Macao', domain: 'CN' },
    '128': { country: 'Macedonia', domain: 'EU/UK' },
    '129': { country: 'Madagascar', domain: 'EU/UK' },
    '130': { country: 'Malawi', domain: 'EU/UK' },
    '131': { country: 'Malaysia', domain: 'EU/UK' },
    '132': { country: 'Maldives', domain: 'EU/UK' },
    '133': { country: 'Mali', domain: 'EU/UK' },
    '134': { country: 'Malta', domain: 'EU/UK' },
    '135': { country: 'Marshall Islands', domain: 'US/NA' },
    '136': { country: 'Martinique', domain: 'EU/UK' },
    '137': { country: 'Mauritania', domain: 'EU/UK' },
    '138': { country: 'Mauritius', domain: 'EU/UK' },
    '139': { country: 'Mayotte', domain: 'EU/UK' },
    '140': { country: 'Mexico', domain: 'LA' },
    '141': { country: 'Micronesia', domain: 'EU/UK' },
    '142': { country: 'Moldova', domain: 'RU' },
    '143': { country: 'Monaco', domain: 'EU/UK' },
    '144': { country: 'Mongolia', domain: 'RU' },
    '145': { country: 'Montenegro', domain: 'EU/UK' },
    '146': { country: 'Montserrat', domain: 'EU/UK' },
    '147': { country: 'Morocco', domain: 'EU/UK' },
    '148': { country: 'Mozambique', domain: 'EU/UK' },
    '149': { country: 'Myanmar', domain: 'SG' },
    '150': { country: 'Namibia', domain: 'EU/UK' },
    '151': { country: 'Nauru', domain: 'AU' },
    '152': { country: 'Nepal', domain: 'EU/UK' },
    '153': { country: 'Netherlands', domain: 'EU/UK' },
    '154': { country: 'New Caledonia', domain: 'EU/UK' },
    '155': { country: 'New Zealand', domain: 'AU' },
    '156': { country: 'Nicaragua', domain: 'LA' },
    '157': { country: 'Niger', domain: 'EU/UK' },
    '158': { country: 'Nigeria', domain: 'EU/UK' },
    '159': { country: 'Niue', domain: 'AU' },
    '160': { country: 'Norfolk Island', domain: 'AU' },
    '161': { country: 'North Korea', domain: 'KR' },
    '162': { country: 'Northern Mariana Islands', domain: 'US/NA' },
    '163': { country: 'Norway', domain: 'EU/UK' },
    '164': { country: 'Oman', domain: 'EU/UK' },
    '165': { country: 'Pakistan', domain: 'EU/UK' },
    '166': { country: 'Palau', domain: 'US/NA' },
    '167': { country: 'Palestinian Territory', domain: 'EU/UK' },
    '168': { country: 'Panama', domain: 'LA' },
    '169': { country: 'Papua New Guinea', domain: 'EU/UK' },
    '170': { country: 'Paraguay', domain: 'LA' },
    '171': { country: 'Peru', domain: 'LA' },
    '172': { country: 'Philippines', domain: 'SG' },
    '173': { country: 'Pitcairn', domain: 'EU/UK' },
    '174': { country: 'Poland', domain: 'EU/UK' },
    '175': { country: 'Portugal', domain: 'EU/UK' },
    '176': { country: 'Puerto Rico', domain: 'US/NA' },
    '177': { country: 'Qatar', domain: 'EU/UK' },
    '178': { country: 'Republic of the Congo', domain: 'EU/UK' },
    '179': { country: 'Reunion', domain: 'EU/UK' },
    '180': { country: 'Romania', domain: 'EU/UK' },
    '181': { country: 'Russia', domain: 'RU' },
    '182': { country: 'Rwanda', domain: 'EU/UK' },
    '183': { country: 'Saint Barth�lemy', domain: 'LA' },
    '184': { country: 'Saint Helena', domain: 'EU/UK' },
    '185': { country: 'Saint Kitts and Nevis', domain: 'LA' },
    '186': { country: 'Saint Lucia', domain: 'EU/UK' },
    '187': { country: 'Saint Martin', domain: 'EU/UK' },
    '188': { country: 'Saint Pierre and Miquelon', domain: 'EU/UK' },
    '189': { country: 'Saint Vincent and the Grenadines', domain: 'EU/UK' },
    '190': { country: 'Samoa', domain: 'EU/UK' },
    '191': { country: 'San Marino', domain: 'EU/UK' },
    '192': { country: 'Sao Tome and Principe', domain: 'EU/UK' },
    '193': { country: 'Saudi Arabia', domain: 'EU/UK' },
    '194': { country: 'Senegal', domain: 'EU/UK' },
    '195': { country: 'Serbia', domain: 'EU/UK' },
    '196': { country: 'Seychelles', domain: 'EU/UK' },
    '197': { country: 'Sierra Leone', domain: 'EU/UK' },
    '198': { country: 'Singapore', domain: 'SG' },
    '199': { country: 'Sint Maarten', domain: 'EU/UK' },
    '200': { country: 'Slovakia', domain: 'EU/UK' },
    '201': { country: 'Solomon Islands', domain: 'EU/UK' },
    '202': { country: 'Somalia', domain: 'EU/UK' },
    '203': { country: 'South Africa', domain: 'EU/UK' },
    '204': { country: 'South Georgia and the South Sandwich Islands', domain: 'EU/UK' },
    '205': { country: 'South Korea', domain: 'KR' },
    '206': { country: 'South Sudan', domain: 'EU/UK' },
    '207': { country: 'Spain', domain: 'EU/UK' },
    '208': { country: 'Sri Lanka', domain: 'EU/UK' },
    '209': { country: 'Sudan', domain: 'EU/UK' },
    '210': { country: 'Suriname', domain: 'LA' },
    '211': { country: 'Svalbard and Jan Mayen', domain: 'EU/UK' },
    '212': { country: 'Swaziland', domain: 'EU/UK' },
    '213': { country: 'Sweden', domain: 'EU/UK' },
    '214': { country: 'Switzerland', domain: 'EU/UK' },
    '215': { country: 'Syria', domain: 'EU/UK' },
    '216': { country: 'Taiwan', domain: 'TW' },
    '217': { country: 'Tajikistan', domain: 'RU' },
    '218': { country: 'Tanzania', domain: 'EU/UK' },
    '219': { country: 'Thailand', domain: 'EU/UK' },
    '220': { country: 'Togo', domain: 'EU/UK' },
    '221': { country: 'Tokelau', domain: 'AU' },
    '222': { country: 'Tonga', domain: 'EU/UK' },
    '223': { country: 'Trinidad and Tobago', domain: 'EU/UK' },
    '224': { country: 'Tunisia', domain: 'EU/UK' },
    '225': { country: 'Turkey', domain: 'EU/UK' },
    '226': { country: 'Turkmenistan', domain: 'RU' },
    '227': { country: 'Turks and Caicos Islands', domain: 'EU/UK' },
    '228': { country: 'Tuvalu', domain: 'EU/UK' },
    '229': { country: 'U.S. Virgin Islands', domain: 'US/NA' },
    '230': { country: 'Uganda', domain: 'EU/UK' },
    '231': { country: 'Ukraine', domain: 'RU' },
    '232': { country: 'United Arab Emirates', domain: 'EU/UK' },
    '233': { country: 'United Kingdom', domain: 'EU/UK' },
    '234': { country: 'United States', domain: 'US/NA' },
    '235': { country: 'United States Minor Outlying Islands', domain: 'US/NA' },
    '236': { country: 'Universal', domain: 'DL' },
    '237': { country: 'Uruguay', domain: 'LA' },
    '238': { country: 'Uzbekistan', domain: 'RU' },
    '239': { country: 'Vanuatu', domain: 'EU/UK' },
    '240': { country: 'Vatican', domain: 'EU/UK' },
    '241': { country: 'Venezuela', domain: 'LA' },
    '242': { country: 'Vietnam', domain: 'SG' },
    '243': { country: 'Wallis and Futuna', domain: 'EU/UK' },
    '244': { country: 'Western Sahara', domain: 'EU/UK' },
    '245': { country: 'Yemen', domain: 'EU/UK' },
    '246': { country: 'Zambia', domain: 'EU/UK' },
    '247': { country: 'Zimbabwe', domain: 'EU/UK' },
    '248': { country: 'Kosovo', domain: 'EU/UK' },
    '249': { country: 'Slovenia', domain: 'EU/UK' },
  },
  "6GHz": {
    '1': { country: 'Afghanistan', domain: 'EU/UK' },
    '2': { country: 'Aland Islands', domain: 'EU/UK' },
    '3': { country: 'Albania', domain: 'EU/UK' },
    '4': { country: 'Algeria', domain: 'EU/UK' },
    '5': { country: 'American Samoa', domain: 'US/NA' },
    '6': { country: 'Andorra', domain: 'EU/UK' },
    '7': { country: 'Angola', domain: 'EU/UK' },
    '8': { country: 'Anguilla', domain: 'EU/UK' },
    '9': { country: 'Antarctica', domain: 'EU/UK' },
    '14': { country: 'Australia', domain: 'AU' },
    '15': { country: 'Austria', domain: 'EU/UK' },
    '18': { country: 'Bahrain', domain: 'EU/UK' },
    '22': { country: 'Belgium', domain: 'EU/UK' },
    '24': { country: 'Benin', domain: 'EU/UK' },
    '25': { country: 'Bermuda', domain: 'EU/UK' },
    '29': { country: 'Bosnia and Herzegovina', domain: 'EU/UK' },
    '30': { country: 'Botswana', domain: 'EU/UK' },
    '31': { country: 'Brazil', domain: 'BR' },
    '32': { country: 'British Indian Ocean Territory', domain: 'EU/UK' },
    '33': { country: 'British Virgin Islands', domain: 'EU/UK' },
    '34': { country: 'Brunei', domain: 'EU/UK' },
    '35': { country: 'Bulgaria', domain: 'EU/UK' },
    '36': { country: 'Burkina Faso', domain: 'EU/UK' },
    '37': { country: 'Burundi', domain: 'EU/UK' },
    '39': { country: 'Cameroon', domain: 'EU/UK' },
    '40': { country: 'Canada', domain: 'CA' },
    '41': { country: 'Cape Verde', domain: 'EU/UK' },
    '42': { country: 'Cayman Islands', domain: 'EU/UK' },
    '43': { country: 'Central African Republic', domain: 'EU/UK' },
    '44': { country: 'Chad', domain: 'EU/UK' },
    '48': { country: 'Cocos Islands', domain: 'EU/UK' },
    '50': { country: 'Comoros', domain: 'EU/UK' },
    '51': { country: 'Cook Islands', domain: 'EU/UK' },
    '53': { country: 'Croatia', domain: 'EU/UK' },
    '55': { country: 'Cura�ao', domain: 'EU/UK' },
    '56': { country: 'Cyprus', domain: 'EU/UK' },
    '57': { country: 'Czech Republic', domain: 'EU/UK' },
    '58': { country: 'Democratic Republic of the Congo', domain: 'EU/UK' },
    '59': { country: 'Denmark', domain: 'EU/UK' },
    '60': { country: 'Djibouti', domain: 'EU/UK' },
    '61': { country: 'Dominica', domain: 'EU/UK' },
    '62': { country: 'Dominican Republic', domain: 'EU/UK' },
    '63': { country: 'East Timor', domain: 'EU/UK' },
    '65': { country: 'Egypt', domain: 'EG' },
    '67': { country: 'Equatorial Guinea', domain: 'EU/UK' },
    '68': { country: 'Eritrea', domain: 'EU/UK' },
    '69': { country: 'Estonia', domain: 'EU/UK' },
    '70': { country: 'Ethiopia', domain: 'EU/UK' },
    '71': { country: 'Falkland Islands', domain: 'EU/UK' },
    '72': { country: 'Faroe Islands', domain: 'EU/UK' },
    '73': { country: 'Fiji', domain: 'EU/UK' },
    '74': { country: 'Finland', domain: 'EU/UK' },
    '75': { country: 'France', domain: 'EU/UK' },
    '76': { country: 'French Guiana', domain: 'EU/UK' },
    '77': { country: 'French Polynesia', domain: 'EU/UK' },
    '78': { country: 'French Southern Territories', domain: 'EU/UK' },
    '79': { country: 'Gabon', domain: 'EU/UK' },
    '80': { country: 'Gambia', domain: 'EU/UK' },
    '81': { country: 'Georgia', domain: 'EU/UK' },
    '82': { country: 'Germany', domain: 'EU/UK' },
    '83': { country: 'Ghana', domain: 'EU/UK' },
    '84': { country: 'Gibraltar', domain: 'EU/UK' },
    '85': { country: 'Greece', domain: 'EU/UK' },
    '86': { country: 'Greenland', domain: 'EU/UK' },
    '87': { country: 'Grenada', domain: 'EU/UK' },
    '88': { country: 'Guadeloupe', domain: 'EU/UK' },
    '89': { country: 'Guam', domain: 'US/NA' },
    '91': { country: 'Guernsey', domain: 'EU/UK' },
    '92': { country: 'Guinea', domain: 'EU/UK' },
    '93': { country: 'Guinea-Bissau', domain: 'EU/UK' },
    '94': { country: 'Guyana', domain: 'EU/UK' },
    '95': { country: 'Haiti', domain: 'EU/UK' },
    '97': { country: 'Hong Kong', domain: 'HK' },
    '98': { country: 'Hungary', domain: 'EU/UK' },
    '99': { country: 'Iceland', domain: 'EU/UK' },
    '102': { country: 'Iran', domain: 'EU/UK' },
    '103': { country: 'Iraq', domain: 'EU/UK' },
    '104': { country: 'Ireland', domain: 'EU/UK' },
    '105': { country: 'Isle of Man', domain: 'EU/UK' },
    '107': { country: 'Italy', domain: 'EU/UK' },
    '108': { country: 'Ivory Coast', domain: 'EU/UK' },
    '110': { country: 'Japan', domain: 'JP' },
    '111': { country: 'Jersey', domain: 'EU/UK' },
    '112': { country: 'Jordan', domain: 'EU/UK' },
    '113': { country: 'Kazakhstan', domain: 'EU/UK' },
    '114': { country: 'Kenya', domain: 'EU/UK' },
    '115': { country: 'Kiribati', domain: 'EU/UK' },
    '116': { country: 'Kuwait', domain: 'EU/UK' },
    '119': { country: 'Latvia', domain: 'EU/UK' },
    '120': { country: 'Lebanon', domain: 'EU/UK' },
    '121': { country: 'Lesotho', domain: 'EU/UK' },
    '122': { country: 'Liberia', domain: 'EU/UK' },
    '123': { country: 'Libya', domain: 'EU/UK' },
    '124': { country: 'Liechtenstein', domain: 'EU/UK' },
    '125': { country: 'Lithuania', domain: 'EU/UK' },
    '126': { country: 'Luxembourg', domain: 'EU/UK' },
    '128': { country: 'Macedonia', domain: 'EU/UK' },
    '129': { country: 'Madagascar', domain: 'EU/UK' },
    '130': { country: 'Malawi', domain: 'EU/UK' },
    '131': { country: 'Malaysia', domain: 'EU/UK' },
    '132': { country: 'Maldives', domain: 'EU/UK' },
    '133': { country: 'Mali', domain: 'EU/UK' },
    '134': { country: 'Malta', domain: 'EU/UK' },
    '135': { country: 'Marshall Islands', domain: 'US/NA' },
    '136': { country: 'Martinique', domain: 'EU/UK' },
    '137': { country: 'Mauritania', domain: 'EU/UK' },
    '138': { country: 'Mauritius', domain: 'EU/UK' },
    '139': { country: 'Mayotte', domain: 'EU/UK' },
    '141': { country: 'Micronesia', domain: 'EU/UK' },
    '143': { country: 'Monaco', domain: 'EU/UK' },
    '145': { country: 'Montenegro', domain: 'EU/UK' },
    '146': { country: 'Montserrat', domain: 'EU/UK' },
    '147': { country: 'Morocco', domain: 'EU/UK' },
    '148': { country: 'Mozambique', domain: 'EU/UK' },
    '150': { country: 'Namibia', domain: 'EU/UK' },
    '152': { country: 'Nepal', domain: 'EU/UK' },
    '153': { country: 'Netherlands', domain: 'EU/UK' },
    '154': { country: 'New Caledonia', domain: 'EU/UK' },
    '155': { country: 'New Zealand', domain: 'AU' },
    '157': { country: 'Niger', domain: 'EU/UK' },
    '158': { country: 'Nigeria', domain: 'EU/UK' },
    '159': { country: 'Niue', domain: 'AU' },
    '160': { country: 'Norfolk Island', domain: 'AU' },
    '161': { country: 'North Korea', domain: 'KR' },
    '162': { country: 'Northern Mariana Islands', domain: 'US/NA' },
    '163': { country: 'Norway', domain: 'EU/UK' },
    '164': { country: 'Oman', domain: 'EU/UK' },
    '165': { country: 'Pakistan', domain: 'EU/UK' },
    '166': { country: 'Palau', domain: 'US/NA' },
    '167': { country: 'Palestinian Territory', domain: 'EU/UK' },
    '169': { country: 'Papua New Guinea', domain: 'EU/UK' },
    '173': { country: 'Pitcairn', domain: 'EU/UK' },
    '174': { country: 'Poland', domain: 'EU/UK' },
    '175': { country: 'Portugal', domain: 'EU/UK' },
    '176': { country: 'Puerto Rico', domain: 'US/NA' },
    '177': { country: 'Qatar', domain: 'EU/UK' },
    '178': { country: 'Republic of the Congo', domain: 'EU/UK' },
    '179': { country: 'Reunion', domain: 'EU/UK' },
    '180': { country: 'Romania', domain: 'EU/UK' },
    '182': { country: 'Rwanda', domain: 'EU/UK' },
    '184': { country: 'Saint Helena', domain: 'EU/UK' },
    '186': { country: 'Saint Lucia', domain: 'EU/UK' },
    '187': { country: 'Saint Martin', domain: 'EU/UK' },
    '188': { country: 'Saint Pierre and Miquelon', domain: 'EU/UK' },
    '189': { country: 'Saint Vincent and the Grenadines', domain: 'EU/UK' },
    '190': { country: 'Samoa', domain: 'EU/UK' },
    '191': { country: 'San Marino', domain: 'EU/UK' },
    '192': { country: 'Sao Tome and Principe', domain: 'EU/UK' },
    '193': { country: 'Saudi Arabia', domain: 'EU/UK' },
    '194': { country: 'Senegal', domain: 'EU/UK' },
    '195': { country: 'Serbia', domain: 'EU/UK' },
    '196': { country: 'Seychelles', domain: 'EU/UK' },
    '197': { country: 'Sierra Leone', domain: 'EU/UK' },
    '199': { country: 'Sint Maarten', domain: 'EU/UK' },
    '200': { country: 'Slovakia', domain: 'EU/UK' },
    '201': { country: 'Solomon Islands', domain: 'EU/UK' },
    '202': { country: 'Somalia', domain: 'EU/UK' },
    '203': { country: 'South Africa', domain: 'EU/UK' },
    '204': { country: 'South Georgia and the South Sandwich Islands', domain: 'EU/UK' },
    '206': { country: 'South Sudan', domain: 'EU/UK' },
    '207': { country: 'Spain', domain: 'EU/UK' },
    '208': { country: 'Sri Lanka', domain: 'EU/UK' },
    '209': { country: 'Sudan', domain: 'EU/UK' },
    '211': { country: 'Svalbard and Jan Mayen', domain: 'EU/UK' },
    '212': { country: 'Swaziland', domain: 'EU/UK' },
    '213': { country: 'Sweden', domain: 'EU/UK' },
    '214': { country: 'Switzerland', domain: 'EU/UK' },
    '215': { country: 'Syria', domain: 'EU/UK' },
    '216': { country: 'Taiwan', domain: 'TW' },
    '218': { country: 'Tanzania', domain: 'EU/UK' },
    '219': { country: 'Thailand', domain: 'EU/UK' },
    '220': { country: 'Togo', domain: 'EU/UK' },
    '222': { country: 'Tonga', domain: 'EU/UK' },
    '223': { country: 'Trinidad and Tobago', domain: 'EU/UK' },
    '224': { country: 'Tunisia', domain: 'EU/UK' },
    '225': { country: 'Turkey', domain: 'EU/UK' },
    '227': { country: 'Turks and Caicos Islands', domain: 'EU/UK' },
    '228': { country: 'Tuvalu', domain: 'EU/UK' },
    '229': { country: 'U.S. Virgin Islands', domain: 'US/NA' },
    '230': { country: 'Uganda', domain: 'EU/UK' },
    '232': { country: 'United Arab Emirates', domain: 'EU/UK' },
    '233': { country: 'United Kingdom', domain: 'EU/UK' },
    '234': { country: 'United States', domain: 'US/NA' },
    '235': { country: 'United States Minor Outlying Islands', domain: 'US/NA' },
    '239': { country: 'Vanuatu', domain: 'EU/UK' },
    '240': { country: 'Vatican', domain: 'EU/UK' },
    '243': { country: 'Wallis and Futuna', domain: 'EU/UK' },
    '244': { country: 'Western Sahara', domain: 'EU/UK' },
    '245': { country: 'Yemen', domain: 'EU/UK' },
    '246': { country: 'Zambia', domain: 'EU/UK' },
    '247': { country: 'Zimbabwe', domain: 'EU/UK' },
    '248': { country: 'Kosovo', domain: 'EU/UK' },
    '249': { country: 'Slovenia', domain: 'EU/UK' }
  },
};

// Reference: https://dlinko365.sharepoint.com/:x:/r/teams/NewHopePlatform/_layouts/15/Doc.aspx?sourcedoc=%7B024B63B5-3A95-43F5-93C2-137509C47AD5%7D&file=Country%20domain-Channel%20Mapping%20table_20251111.xlsx&action=default&mobileredirect=true
export const channelByCountryDomain = {
  "2.4GHz": {
    "AU": {
      indoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      outdoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
    },
    "US/NA": {
      indoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      outdoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    },
    "EU/UK": {
      indoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      outdoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
    },
    "CN": {
      indoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      outdoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
    },
    "SG": {
      indoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      outdoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
    },
    "KR": {
      indoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      outdoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
    },
    "JP": {
      indoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      outdoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
    },
    "RU": {
      indoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      outdoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
    },
    "IN": {
      indoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      outdoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
    },
    "HK": {
      indoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      outdoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    },
    "DL": {
      indoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
      outdoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11],
    },
    "BY": {
      indoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      outdoor: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
    },
  },
  "5GHz": {
    "AU": {
      indoor: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 132, 136, 140, 149, 153, 157, 161, 165],
      outdoor: [100, 104, 108, 112, 132, 136, 140, 149, 153, 157, 161, 165],
    },
    "CA": {
      indoor: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 132, 136, 140, 149, 153, 157, 161, 165],
      outdoor: [52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 149, 153, 157, 161, 165],
    },
    "CN": {
      indoor: [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
      outdoor: [36, 40, 44, 48, 52, 56, 60, 64, 149, 153, 157, 161, 165],
    },
    "SG": {
      indoor: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 132, 136, 140, 149, 153, 157, 161, 165],
      outdoor: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 149, 153, 157, 161, 165],
    },
    "TW": {
      indoor: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 132, 136, 140, 149, 153, 157, 161, 165],
      outdoor: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 149, 153, 157, 161, 165],
    },
    "US/NA": {
      indoor: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 132, 136, 140, 149, 153, 157, 161, 165],
      outdoor: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 132, 136, 140, 149, 153, 157, 161, 165],
    },
    "LA": {
      indoor: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 132, 136, 140, 149, 153, 157, 161, 165],
      outdoor: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 132, 136, 140, 149, 153, 157, 161, 165],
    },
    "EU/UK": {
      indoor: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
      outdoor: [100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
    },
    "IL": {
      indoor: [36, 40, 44, 48, 52, 56, 60, 64],
      outdoor: [],
    },
    "KR": {
      indoor: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 149, 153, 157, 161, 165],
      outdoor: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 149, 153, 157, 161, 165],
    },
    "BR": {
      indoor: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 132, 136, 140, 149, 153, 157, 161, 165],
      outdoor: [100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 149, 153, 157, 161, 165],
    },
    "RU": {
      indoor: [36, 40, 44, 48, 52, 56, 60, 64, 132, 136, 140, 144, 149, 153, 157, 161, 165],
      outdoor: [36, 40, 44, 48, 52, 56, 60, 64, 132, 136, 140, 144, 149, 153, 157, 161, 165],
    },
    "IN": {
      indoor: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 132, 136, 140, 149, 153, 157, 161, 165],
      outdoor: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 132, 136, 140, 149, 153, 157, 161, 165, 169, 173],
    },
    "HK": {
      indoor: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 132, 136, 140, 149, 153, 157, 161, 165],
      outdoor: [100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 149, 153, 157, 161, 165],
    },
    "JP": {
      indoor: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 144],
      outdoor: [100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140, 144],
    },
    "EG": {
      indoor: [36, 40, 44, 48, 52, 56, 60, 64],
      outdoor: [149, 153, 157, 161],
    },
    "DL": {
      indoor: [36, 40, 44, 48,],
      outdoor: [36, 40, 44, 48,],
    },
    "BY": {
      indoor: [36, 40, 44, 48, 52, 56, 60, 64, 100, 104, 108, 112, 116, 120, 124, 128, 132, 136, 140],
      outdoor: [132, 136, 140],
    }
  },
  "6GHz": {
    "US/NA": {
      indoor: [1, 5, 9, 13, 17, 21, 25, 29, 33, 37, 41, 45, 49, 53, 57, 61, 65, 69, 73, 77, 81, 85, 89, 93, 97, 101, 105, 109, 113, 117, 121, 125, 129, 133, 137, 141, 145, 149, 153, 157, 161, 165, 169, 173, 177, 181, 185, 189, 193, 197, 201, 205, 209, 213, 217, 221, 225, 229, 233],
      outdoor: [1, 5, 9, 13, 17, 21, 25, 29, 33, 37, 41, 45, 49, 53, 57, 61, 65, 69, 73, 77, 81, 85, 89, 93, 117, 121, 125, 129, 133, 137, 141, 145, 149, 153, 157, 161, 165, 169, 173, 177, 181, 185],
    },
    "CA": {
      indoor: [1, 5, 9, 13, 17, 21, 25, 29, 33, 37, 41, 45, 49, 53, 57, 61, 65, 69, 73, 77, 81, 85, 89, 93, 97, 101, 105, 109, 113, 117, 121, 125, 129, 133, 137, 141, 145, 149, 153, 157, 161, 165, 169, 173, 177, 181, 185, 189, 193, 197, 201, 205, 209, 213, 217, 221, 225, 229, 233],
      outdoor: []
    },
    "EU/UK": {
      indoor: [1, 5, 9, 13, 17, 21, 25, 29, 33, 37, 41, 45, 49, 53, 57, 61, 65, 69, 73, 77, 81, 85, 89, 93],
      outdoor: []
    },
    "AU": {
      indoor: [1, 5, 9, 13, 17, 21, 25, 29, 33, 37, 41, 45, 49, 53, 57, 61, 65, 69, 73, 77, 81, 85, 89, 93],
      outdoor: []
    },
    "BR": {
      indoor: [1, 5, 9, 13, 17, 21, 25, 29, 33, 37, 41, 45, 49, 53, 57, 61, 65, 69, 73, 77, 81, 85, 89, 93, 97, 101, 105, 109, 113, 117, 121, 125, 129, 133, 137, 141, 145, 149, 153, 157, 161, 165, 169, 173, 177, 181, 185, 189, 193, 197, 201, 205, 209, 213, 217, 221, 225, 229, 233],
      outdoor: []
    },
    "HK": {
      indoor: [1, 5, 9, 13, 17, 21, 25, 29, 33, 37, 41, 45, 49, 53, 57, 61, 65, 69, 73, 77, 81, 85, 89, 93],
      outdoor: []
    },
    "JP": {
      indoor: [1, 5, 9, 13, 17, 21, 25, 29, 33, 37, 41, 45, 49, 53, 57, 61, 65, 69, 73, 77, 81, 85, 89, 93],
      outdoor: []
    },
    "KR": {
      indoor: [1, 5, 9, 13, 17, 21, 25, 29, 33, 37, 41, 45, 49, 53, 57, 61, 65, 69, 73, 77, 81, 85, 89, 93, 97, 101, 105, 109, 113, 117, 121, 125, 129, 133, 137, 141, 145, 149, 153, 157, 161, 165, 169, 173, 177, 181, 185, 189, 193, 197, 201, 205, 209, 213, 217, 221, 225, 229, 233],
      outdoor: []
    },
    "TW": {
      indoor: [1, 5, 9, 13, 17, 21, 25, 29, 33, 37, 41, 45, 49, 53, 57, 61, 65, 69, 73, 77, 81, 85, 89, 93],
      outdoor: [],
    }
  },
};